import { AdvertiserEntityType } from '../generated/graphql'
import { TranslateFunc } from './safe_translate'

// Advertiser Entity Types
export const SELLER_TOKEN = 'ENTITY_TYPE:SELLER_CENTRAL_ENTITY'
export const VENDOR_TOKEN = 'ENTITY_TYPE:BRAND'
export const ENTITY_TYPE_AMAZON_DSP_TOKEN = 'ENTITY_TYPE:DSP_ADVERTISING_ACCOUNT'
export const KDP_TOKEN = 'ENTITY_TYPE:KDP_AUTHOR'

export const ADVERTISER_ENTITY_TYPE_TO_TOKEN = new Map()
  .set(AdvertiserEntityType.SellerCentralEntity, SELLER_TOKEN)
  .set(AdvertiserEntityType.Brand, VENDOR_TOKEN)
  .set(AdvertiserEntityType.DspAdvertisingAccount, ENTITY_TYPE_AMAZON_DSP_TOKEN)
  .set(AdvertiserEntityType.KdpAuthor, KDP_TOKEN)

export const getAdvertiserEntityTypeTranslationToken = (advertiserEntityType: AdvertiserEntityType | string): string =>
  ADVERTISER_ENTITY_TYPE_TO_TOKEN.get(advertiserEntityType.toString().toUpperCase())
export const getAdvertiserEntityTypeTranslation = (advertiserEntityType: AdvertiserEntityType | string, translate: TranslateFunc): string =>
  translate(getAdvertiserEntityTypeTranslationToken(advertiserEntityType))
